import { render } from "./BookMsgStatistics.vue?vue&type=template&id=9f55d2b4"
import script from "./BookMsgStatistics.vue?vue&type=script&lang=js"
export * from "./BookMsgStatistics.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__